import { render, staticRenderFns } from "./receive-table.vue?vue&type=template&id=36172825&scoped=true&"
import script from "./receive-table.vue?vue&type=script&lang=js&"
export * from "./receive-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36172825",
  null
  
)

export default component.exports